export default {
  name: "BolideAssistant",

  props: {
    is_open: Boolean,
    tiles: Array,
    activeProperty: Object,
  },

  emits: ["close-assistant"],

  data() {
    return ({
      user_message: "",
      messages: [
        {
          sender: "assistant",
          text: "Hello! I'm the Department of Water and Sanitation AI Assistant. How can I help you today?",
        },
      ],
    });
  },

  watch: {
    // Auto-scroll chat when messages change
    messages() {
      this.$nextTick(() => {
        const el = this.$refs.chat_body;
        if (el) {
          el.scrollTop = el.scrollHeight;
        }
      });
    },

    // Lock body scroll when assistant is open
    is_open(isOpen) {
      document.body.classList.toggle("chatbot-lock", isOpen);
    },
  },

  mounted() {
    // Click outside to close
    document.addEventListener("mousedown", this.handleClickOutside);
    document.addEventListener("touchstart", this.handleClickOutside);
  },

  beforeUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    document.removeEventListener("touchstart", this.handleClickOutside);
    document.body.classList.remove("chatbot-lock");
  },

  methods: {
    /* ===============================
       UI CONTROL
    =============================== */

    close_assistant() {
      this.$emit("close-assistant");
    },

    handleClickOutside(event) {
      if (!this.is_open) return;

      const panel = this.$refs.chatbot;
      if (panel && !panel.contains(event.target)) {
        this.close_assistant();
      }
    },

    /* ===============================
       CHAT LOGIC
    =============================== */

    send() {
      if (!this.user_message.trim()) return;

      const text = this.user_message.trim();

      // User message
      this.messages.push({ sender: "user", text });

      this.user_message = "";

      // Simulated AI delay
      setTimeout(() => {
        this.generateReply(text.toLowerCase());
      }, 350);
    },

    reply(text) {
      this.messages.push({ sender: "assistant", text });
    },

    generateReply(q) {
      const p = this.activeProperty;

      if (!p) {
        return this.reply("Please select a property first.");
      }

      // Example replies
      if (q.includes("occupancy")) {
        return this.reply(
          `The occupancy for ${p.title} is ${p.propertyOverview.occupancy}.`
        );
      }

      if (q.includes("energy")) {
        return this.reply(
          `${p.title} energy efficiency is ${p.stats}, trending ${p.trend}.`
        );
      }

      const mgmt = p.tileCards?.find((c) => c.type === "details");
      if (mgmt && q.includes("management")) {
        return this.reply(
          `Management contact:\n${mgmt.details.phone} — ${mgmt.details.email}`
        );
      }

      // Fallback
      this.reply(
        "I'm learning! Ask about occupancy, energy, emergency contacts, or management."
      );
    },
  },
};
